<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="fixed l r t mt44 pad5 BGwhite" style="z-index:5">
    <div class="ml10 flex mr10 BGf0 radius30 nowrap">
      <img src="@/assets/img/icon-search.png" class="width22px pad2 ml10 mr10 pointer" @click="getInfoList" alt="">
      <input type="text" class="flex1 size14" style="height:34px;background:none;" placeholder="请输入搜索关键词" v-model.trim="keyword"
        v-on:keyup.enter="getInfoList" key="1" />
      <img src="@/assets/img/icon32.png" v-if="keyword" @click="keyword='';getInfoList();"
        class="width22px pad4 BGwhite pointer opacity7 radius20 ml10 mr6" alt="">
    </div>
  </div>
  <div class="height60px"></div>

  <van-empty v-if="infoList.length==0" />
  <div class="ml10 mr10">
    <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="flex mb10 nowrap BGwhite pad13 radius8" v-for="item,index in infoList" :key="index"
        @click="$router.push({path:'/shop/msgDetail',query:{id:item.id,type:1,title:'消息详情'}})">
        <img @click.stop="$router.push({
                  path: '/shop/detail',
                  query: { goods_id: item.goods_id },
                })" :src="item.thumb" :onerror="Imgerror" class="radius30 height52px width52px" alt="">
        <div class="flex1 ml10">
          <div class="flex between mb15 nowrap">
            <p class="ellipsis width120px size18 weight">{{ item.name }}</p>
            <p class="C999 nowrap size12 ">{{ item.reply_time }}</p>
          </div>
          <p class="size14 opacity9 C888">{{ item.remarks }} </p>
        </div>
      </div>
    </van-list>
  </div>
  <WsTabbar></WsTabbar>
</template>

<script>
import ajax from "@/utils/request.js";
export default {
  data () {
    return {
      page: 1,
      infoList: [],
      loading: false,
      finished: false,
      keyword: ''
    }
  },
  watch: {
  },
  methods: {
    apply () {
      this.showDialog({
        showCancelButton: true,
        cancelButtonText: "退出申请",
        confirmButtonText: "重新选择",
        message: '抱歉！您的观点不符合本网站经营理念\n感谢您的参与!',
      }).then(() => {
        console.log("正确")
      }).catch(() => {
        console.log("错误")
      });
    },
    next () {
      history.forward()
    },
    getInfoList () {
      this.loading = true
      this.infoList = []
      return ajax.post("products/getmessagelist", { page: this.page, keyword: this.keyword }).then(res => {
        if (res.data.length < 10) {
          this.infoList = this.infoList.concat(res.data);
          this.finished = true
        } else {
          this.infoList = this.infoList.concat(res.data);
          this.page++
        }
      }).catch(() => {
        this.finished = true
      })
    },
    onLoad () {
      this.getInfoList().finally(() => {
        this.loading = false
      })
    }
  },
  created () {
    this.getInfoList().finally(() => {
      this.loading = false
    })
  }
}
</script>

<style>

</style>
